import React, { useCallback, useState } from 'react'

import {Grid, CircularProgress} from '@mui/material'
import { useSelector } from 'react-redux'

import useStyles from './styles.js'

import Match from './match/Match.js'
import { discipline_all, getActualSeason, getDays, season_all } from '../../bdd/bddSTUB.js'
import Select_Dsas from '../../dsasComponents/Select_Dsas.js'
import FilterGroupProvider from '../../dsasComponents/FilterGroupProvider.js'
import { isAdminDSAS } from '../../actions/auth.js'
import { fetchCompetitions, fetchMatchs, fetchTeams } from '../../api/index.js'
import { useFetch } from '../../filters/useFetch.js'
import { reload } from '../../filters/reload.js'
import { FETCH_ALL_COMPETITION, FETCH_ALL_MATCH, FETCH_ALL_TEAM } from '../../constants/actionTypes.js'
import Pagination from '../../dsasComponents/pagination/Pagination.js'

const Matchs = ( { setCurrentId }) => {
    const classes = useStyles();

    //const matchsCollection = useSelector((state) => state.matchs)

    // FILTERS
    const [filters, setFilters] = useState({discipline : '', competition : '', day : '', provider : '', season : getActualSeason()})

    const [matchs, loading] = useFetch(fetchMatchs, filters, ['competition', 'day'], FETCH_ALL_MATCH)
    const [competitions, loadingCompetition] = useFetch(fetchCompetitions, filters, undefined, FETCH_ALL_COMPETITION)

    const [teams, loadingTeams] = useFetch(fetchTeams, filters, ['competition'], FETCH_ALL_TEAM)


    const daysAvailable = useCallback(() => {

        let days = []
        if(filters.competition===''){

            // On récupère le max de nbDays et le max de nbTeamFinalPhase
            const [maxNbDays, maxNbTeamFinalPhase] = competitions.reduce((acc, curr) => {
                acc = [Math.max(acc[0], curr.nbDays), Math.max(acc[1], curr.nbTeamFinalPhase)]

                return acc
            }, [0, 0])

            days = getDays(maxNbDays, maxNbTeamFinalPhase)
        }else{
            let selectedCompetition = competitions.find(c => c._id === filters.competition)

            if(selectedCompetition)
                days = getDays(selectedCompetition.nbDays, selectedCompetition.nbTeamFinalPhase)
            else{
                const [maxNbDays, maxNbTeamFinalPhase] = competitions.reduce((acc, curr) => {
                    acc = [Math.max(acc[0], curr.nbDays), Math.max(acc[1], curr.nbTeamFinalPhase)]
    
                    return acc
                }, [0, 0])
    
                days = getDays(maxNbDays, maxNbTeamFinalPhase)
            }
        }

        return days

    }, [competitions])



    return (
        loading ? <CircularProgress /> : (<>
            <div>
            {isAdminDSAS() && <FilterGroupProvider
                        classname={classes.customInput}
                        labelId = {"provider_label"}
                        label = {"Groupe"}
                        selectId = {"provider"}
                        name = {"provider"}
                        filters = {filters} 
                        setFilters = {setFilters}
                    />}
                <Select_Dsas
                            className={classes.selectInput}
                            labelId = {"discipline_label"}
                            label = {"Discipline"}
                            selectId = {"discipline"}
                            name = {"discipline"}
                            value = {filters.discipline}
                            items = {discipline_all}
                            onChange = {(e) => setFilters(state => ({...state, discipline : e.target.value}))}
                            onReset = {(e) => setFilters(state => ({...state, discipline : ''}))}
                />

                <Select_Dsas
                            className={classes.selectInput}
                            labelId = {"season_label"}
                            label = {"Saison"}
                            selectId = {"season"}
                            name = {"season"}
                            value = {filters.season}
                            items = {season_all}
                            onChange = {(e) => setFilters(state => ({...state, season : e.target.value}))}
                            onReset = {(e) => setFilters(state => ({...state, season : ''}))}
                />

                <Select_Dsas
                            isError = {!filters.competition}
                            className={classes.selectInput}
                            labelId = {"competition_label"}
                            label = {"Compétition"}
                            selectId = {"competition"}
                            name = {"competition"}
                            value = {filters.competition}
                            items = {competitions}
                            onChange = {(e) => setFilters(state => ({...state, competition : e.target.value}))}
                            onReset = {(e) => setFilters(state => ({...state, competition : ''}))}
                />

                <Select_Dsas
                            isError = {!filters.day}
                            className={classes.selectInput}
                            labelId = {"day_label"}
                            label = {"Journée"}
                            selectId = {"day"}
                            name = {"day"}
                            value = {filters.day}
                            items = {daysAvailable()}
                            onChange = {(e) => setFilters(state => ({...state, day : e.target.value}))}
                            onReset = {(e) => setFilters(state => ({...state, day : ''}))}
                />

            </div>

            <Pagination items={matchs} classes={classes}>
                {matchs.map(match => 
                    <Match match={match} setCurrentId={setCurrentId} reload={()=> reload(setFilters)}/>
                )}
            </Pagination></>
        )
    )
}

export default Matchs